/* ==========================================================================
   AGC Tier Selector — Hot Sale 2026 (HOTSALE 2026 theme)
   Click programático en el LABEL del bar (no en radio) — más natural.
   Override de strike + chip solo UNA vez al boot.
   ========================================================================== */

(function () {
  'use strict';

  var KACHING_BLOCK_ID = 'e2f669ad-c8fa-4835-a86e-faab44ea639c';
  var COOKIE_NAME = 'agc_tier_last';
  var COOKIE_DAYS = 7;

  /* ANNUAL UPSELL T1 — custom (bypass Kaching que se buggea con upsells opt-in)
     Producto: Ritual Anual 3 Filtros de Reemplazo (one-time, $1,190 / $1,770)

     ┌─────────────────────────────────────────────────────────────────────┐
     │  FEATURE FLAG PDP CROSS-SELL                                        │
     │  Pedro 2026-05-26: desactivado por hipótesis de parálisis (cliente │
     │  ya tomó decisiones de color/tier/bundle, +1 decisión añade        │
     │  cognitive load). El cart cross-sell SIGUE activo (no se toca).    │
     │                                                                     │
     │  Para REACTIVAR: cambiar `false` → `true` en la línea de abajo.    │
     │  Push: shopify theme push --theme=162208612600 \\                   │
     │        --only=assets/agc-tier-selector.js --path=theme \\           │
     │        --allow-live --nodelete                                      │
     │                                                                     │
     │  Pedro 2026-06-06: APAGADO. Cross-sell del PDP removido por noise   │
     │  en Meta Pixel + decisión estratégica. Cart drawer cross-sell sigue │
     │  activo (mecánica separada, no afectada por este flag).             │
     └─────────────────────────────────────────────────────────────────────┘ */
  var ANNUAL_PDP_ENABLED = false;

  /* ┌───────────────────────────────────────────────────────────────────────┐
     │  FEATURE FLAG — CUSTOM URGENCY BAR (Pedro 2026-05-29)                 │
     │  Renderiza barra custom con datos REALES de inventario.               │
     │  Asume que Kaching timer está APAGADO desde Kaching admin.            │
     │                                                                       │
     │  ROLLBACK TRIGGER (decir cualquiera de estas frases):                │
     │    • "vuelve la barra de timer de kaching normal"                     │
     │    • "rollback urgency bar"                                           │
     │    • "restaura kaching timer"                                         │
     │                                                                       │
     │  Steps cuando uses trigger:                                           │
     │    1. Yo flip URGENCY_BAR_ENABLED a `false` + push LIVE (segundos)   │
     │    2. Tú reactivas el timer en Kaching admin                          │
     │    Resultado: custom bar desaparece, Kaching timer vuelve a aparecer │
     └───────────────────────────────────────────────────────────────────────┘ */
  var URGENCY_BAR_ENABLED = true;
  var URGENCY_BAR_STOCK_TOTAL = 3000; /* debe match agc-hot-bar.liquid stock_total */

  /* Pedro 2026-06-09: rollback Set Anual 4 → Ritual Anual 3 (3x2 @ $1,190).
     Producto Ritual Anual 3 Filtros de Reemplazo · variant 47967386009848
     (SKU aguacero12). Cobertura 12 meses · primer renewal mes 12.
     PDP cross-sell apagado (ANNUAL_PDP_ENABLED=false) — solo cart drawer LIVE. */
  var ANNUAL_VARIANT_ID = 47967386009848;
  var ANNUAL_PRODUCT_HANDLE = 'ritual-anual-3-filtros-de-reemplazo';
  var ANNUAL_TITLE = 'Set Anual Filtros';
  /* 'card' = legacy (image + multi-row) | 'pill' = inline pill compacto.
     Flag para rollback en 1 línea si no gana. */
  var ANNUAL_DISPLAY_MODE = 'pill';
  var ANNUAL_PRICE_FMT = '$ 1,770';
  var ANNUAL_COMPARE_FMT = '$ 2,360';
  var ANNUAL_IMAGE = 'https://cdn.shopify.com/s/files/1/0706/9063/6024/files/23123wqdasda_1.png?v=1779631342&height=88';
  /* Imagen PNG del filtro suelto (Pedro 2026-06-06) — usada para el visual
     "3 filtros + 1 GRATIS" en el pill (4 thumbnails chiquitos Apple-style). */
  var ANNUAL_FILTER_PNG = 'https://cdn.shopify.com/s/files/1/0706/9063/6024/files/572806079.png?v=1780782350&width=80';
  var ANNUAL_STATE_KEY = 'agc_annual_upsell_checked';

  var TIER_OVERRIDES = {
    2: {
      strikePrice: '$ 6,340',
      savingsText: 'Ahorra $2,470 - 39% OFF'
    },
    3: {
      strikePrice: '$ 10,700',
      savingsText: 'Ahorra $4,895 - 46% OFF'
    }
  };

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 864e5);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax';
  }
  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  }

  function markKachingBars() {
    var block = document.querySelector('[data-deal-block-id="' + KACHING_BLOCK_ID + '"]');
    if (!block) return false;
    var bars = block.querySelectorAll('.kaching-bundles__bar');
    if (bars.length === 0) return false;
    bars.forEach(function (bar, idx) {
      bar.setAttribute('data-agc-bar-index', String(idx + 1));
    });
    return true;
  }

  function applyTierOverrides() {
    var block = document.querySelector('[data-deal-block-id="' + KACHING_BLOCK_ID + '"]');
    if (!block) return;

    Object.keys(TIER_OVERRIDES).forEach(function (tier) {
      var bar = block.querySelector('.kaching-bundles__bar[data-agc-bar-index="' + tier + '"]');
      if (!bar) return;

      var override = TIER_OVERRIDES[tier];

      var strikeEl = bar.querySelector('.kaching-bundles__bar-full-price');
      if (!strikeEl) strikeEl = bar.querySelector('s, del');
      if (strikeEl && strikeEl.textContent.trim() !== override.strikePrice) {
        strikeEl.textContent = override.strikePrice;
        strikeEl.setAttribute('data-agc-overridden', 'strike');
      }

      if (override.savingsText) {
        var allEls = bar.querySelectorAll('span, div, p');
        for (var i = 0; i < allEls.length; i++) {
          var el = allEls[i];
          var txt = (el.textContent || '').trim();
          var hasChildWithText = false;
          for (var j = 0; j < el.children.length; j++) {
            if ((el.children[j].textContent || '').trim().length > 0) {
              hasChildWithText = true;
              break;
            }
          }
          if (!hasChildWithText && /^Ahorra(s)?\s+\$/i.test(txt)) {
            if (txt !== override.savingsText) {
              el.textContent = override.savingsText;
              el.setAttribute('data-agc-overridden', 'savings');
            }
            break;
          }
        }
      }
    });
  }

  function applyBodyClass(tier) {
    document.body.classList.remove('agc-tier-active-1', 'agc-tier-active-2', 'agc-tier-active-3');
    document.body.classList.add('agc-tier-active-' + tier);
  }

  // Click en el LABEL del bar — más natural que click en radio
  function selectKachingBar(tier) {
    var block = document.querySelector('[data-deal-block-id="' + KACHING_BLOCK_ID + '"]');
    if (!block) return;
    var targetBar = block.querySelector('.kaching-bundles__bar[data-agc-bar-index="' + tier + '"]');
    if (!targetBar) return;

    // Si el bar ya está selected, no hacer nada
    if (targetBar.classList.contains('kaching-bundles__bar--selected')) return;

    // Click en el label (envuelve toda la fila clickable del bar)
    var label = targetBar.querySelector('label.kaching-bundles__bar-container');
    if (label) {
      try { label.click(); } catch (e) {}
    } else {
      // Fallback: radio
      var radio = targetBar.querySelector('input[type="radio"]');
      if (radio && !radio.checked) {
        try { radio.click(); } catch (e) {}
      }
    }
  }

  function switchTier(tier, opts) {
    opts = opts || {};
    applyBodyClass(tier);
    setCookie(COOKIE_NAME, tier, COOKIE_DAYS);

    document.querySelectorAll('[data-agc-tier-cap]').forEach(function (c) {
      var t = parseInt(c.getAttribute('data-tier'), 10);
      c.setAttribute('aria-selected', t === tier ? 'true' : 'false');
    });

    if (!opts.skipKachingClick) {
      // Delay para no interferir si Kaching está renderizando
      setTimeout(function () { selectKachingBar(tier); }, 50);
    }

    /* Pedro 2026-06-05: Microanimation Apple-style. Cuando user clickea tier,
       la barra recién seleccionada aparece con fade+slide 350ms. La clase es
       transitoria — se quita post-animación. NO corre en page load porque
       --selected ya viene seteado desde el initial state. */
    if (!opts.skipAnimation) {
      setTimeout(function () {
        var block = document.querySelector('[data-deal-block-id="' + KACHING_BLOCK_ID + '"]');
        if (!block) return;
        var activeBar = block.querySelector('.kaching-bundles__bar--selected');
        if (!activeBar) return;
        activeBar.classList.add('agc-tier-just-selected');
        setTimeout(function () {
          activeBar.classList.remove('agc-tier-just-selected');
        }, 400);
      }, 120);
    }

    try {
      if (window._learnq && window._learnq.push) {
        window._learnq.push(['track', 'Tier Selected', { tier: tier }]);
      }
    } catch (e) {}
  }

  function init() {
    var wrap = document.querySelector('[data-agc-tier-wrap]');
    if (!wrap) return;

    wrap.querySelectorAll('[data-agc-tier-cap]').forEach(function (cap) {
      cap.addEventListener('click', function () {
        var tier = parseInt(cap.getAttribute('data-tier'), 10);
        if (tier) switchTier(tier);
      });
    });

    /* Default Tier 1 (revertido 2026-05-26): el experimento de default T2 (25-may 19:13)
       en 9h mostró T1 SUBIENDO 66.7% → 76.6% (reactancia anti-default) + AOV bajando 30%.
       Hipótesis: cliente price-sensitive ACTIVAMENTE elige T1 cuando le imponen T2.
       Con el nuevo crosell del Set Anual (visible solo en T1), default T1 maximiza
       exposure del upsell. Cookie sticky preserva elección del cliente. */
    var savedTier = parseInt(getCookie(COOKIE_NAME), 10);
    var initialTier = (savedTier === 1 || savedTier === 2 || savedTier === 3) ? savedTier : 1;
    /* skipAnimation: en page load no queremos que la card haga fade-in (UX natural). */
    switchTier(initialTier, { skipAnimation: true });

    wrap.classList.add('is-ready');
  }

  /* Removido 2026-05-26: ensureUpsellsChecked + upsellGuard + change listener.
     Kaching v1849 cambió checkboxes de <input> a <span role="button"> con clase
     `.kaching-bundles__upsell__checkbox--selected`. Los defenses legacy buscaban
     inputs que ya no existen — no aplicaban — pero el setInterval cada 2s y el
     listener global 'change' (capture=true) estaban interfiriendo con el handler
     de click de Kaching, rompiendo el toggle del upsell opt-in del Set Anual a
     los ~5s del boot. Confianza en CSS de ocultamiento T2/T3 es suficiente:
     `body:not(.agc-tier-active-1) .kaching-bundles__upsell__checkbox { display:none }`
     hace que cliente no pueda interactuar con el checkbox de filtros gratis,
     mientras que en T1 el checkbox del Set Anual queda 100% bajo control de Kaching. */

  function boot() {
    /* Pedro 2026-06-06: si cross-sell PDP está apagado, limpiar sessionStorage
       de cualquier user que tenía flag set en sesión activa — evita que el main
       ATC hook añada el annual automáticamente con el pill ya removido visualmente. */
    if (!ANNUAL_PDP_ENABLED) {
      try { sessionStorage.removeItem(ANNUAL_STATE_KEY); } catch (e) {}
    }

    var maxRetries = 50;
    var retries = 0;
    var poll = setInterval(function () {
      var marked = markKachingBars();
      if (marked) {
        clearInterval(poll);
        applyTierOverrides();
        injectAnnualUpsellT1();
        init();
        /* setupTimerMove disabled (Pedro 2026-06-02): Kaching admin maneja
           position + color (red custom). Si re-habilitas, el CSS recovery
           verde puede chocar con el admin styling. */
      } else if (++retries >= maxRetries) {
        clearInterval(poll);
        init();
      }
    }, 200);

    /* Custom urgency bar — render + tick (gated by URGENCY_BAR_ENABLED flag)
       tickUrgencyBar: actualiza units/pct cada 30s
       tickUrgencyBarCountdown: actualiza countdown D/H/M/S cada 1s (segundos visibles) */
    renderUrgencyBar();
    setInterval(tickUrgencyBar, 30000);
    setInterval(tickUrgencyBarCountdown, 1000);

    /* ATC loading state — optimistic UI sutil para enmascarar delay del cart drawer */
    setupATCLoadingState();

    // Hook al ATC del bundle — agregar variant del Set Anual si está checked
    hookAnnualATC();

    // Ocultar nombre del bundle Kaching en cart drawer ("2 Duchas + Filtro" etc.)
    // Mantiene visibles otros discount codes legítimos (ej. CEROCLORO).
    setupKachingDealNameHider();
  }

  /* Mover .kaching-bundles__timer arriba del tier selector (Pedro 2026-05-28).
     Por default Kaching lo renderiza dentro de su block, debajo del tier wrap.
     Lo extraemos y lo insertamos como sibling inmediato ANTES del tier wrap.
     MutationObserver re-aplica si Kaching re-renderiza al cambiar tier. */
  function moveTimerAboveTierWrap() {
    var timer = document.querySelector('.kaching-bundles__timer');
    var tierWrap = document.querySelector('[data-agc-tier-wrap], .agc-tier-wrap');
    if (!timer || !tierWrap) return false;
    if (timer.nextElementSibling === tierWrap) return true; /* already in place */
    tierWrap.parentNode.insertBefore(timer, tierWrap);
    timer.setAttribute('data-agc-moved', '1');
    return true;
  }

  function setupTimerMove() {
    moveTimerAboveTierWrap();
    /* Persistir contra re-renders de Kaching durante primeros 30s — luego stable. */
    var obs = new MutationObserver(function () {
      moveTimerAboveTierWrap();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 30000);
  }

  /* ATC loading state (Pedro 2026-05-31) — Optimistic UI sutil.
     Al click del botón "Agregar a mi carrito", muestra spinner instantáneo
     para enmascarar el delay entre click y apertura del cart drawer.

     IMPORTANTE: usa DOM child injection (span.agc-atc-spinner), NO pseudo ::after,
     porque el ATC ya tiene ::before y ::after definidos inline para el gradient
     premium del botón (sección main-product.liquid). Conflicto de pseudo confirmado
     vía Playwright inspection 2026-05-31. */
  function setupATCLoadingState() {
    var atc = document.querySelector('.product-form__submit');
    if (!atc) return;
    if (atc.hasAttribute('data-agc-atc-loading-bound')) return;
    atc.setAttribute('data-agc-atc-loading-bound', '1');

    /* Inject spinner element ONCE (display:none hasta loading) */
    var spinner = atc.querySelector('.agc-atc-spinner');
    if (!spinner) {
      spinner = document.createElement('span');
      spinner.className = 'agc-atc-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      atc.appendChild(spinner);
    }

    atc.addEventListener('click', function () {
      if (atc.classList.contains('is-loading')) return; /* evitar doble click */
      atc.classList.add('is-loading');

      var cleanup = function () { atc.classList.remove('is-loading'); };

      /* APPROACH A: si user tenía pre-seleccionado el Set Anual (flag ANNUAL_STATE_KEY='1'),
         añadirlo al cart DESPUÉS de que el bundle se procesó. Esto dispara un AddToCart
         legítimo asociado al click del main ATC (intent real del usuario). */
      var shouldAddAnnual = false;
      try {
        shouldAddAnnual = sessionStorage.getItem(ANNUAL_STATE_KEY) === '1';
      } catch (e) {}

      function maybeAddAnnualPostBundle() {
        if (!shouldAddAnnual) return;
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            /* Si ya está en cart (race / re-click), skip */
            var alreadyIn = (cart.items || []).some(function (i) {
              return Number(i.variant_id) === ANNUAL_VARIANT_ID;
            });
            if (alreadyIn) return null;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({
                items: [{ id: ANNUAL_VARIANT_ID, quantity: 1 }],
                sections: ['cart-drawer', 'cart-icon-bubble']
              })
            }).then(function (r) { return r.json(); });
          })
          .then(function (state) {
            /* Re-render cart drawer con annual incluido */
            if (state && state.sections) {
              var drawerEl = document.querySelector('cart-drawer');
              if (drawerEl && typeof drawerEl.renderContents === 'function') {
                drawerEl.renderContents(state);
              }
            }
          })
          .catch(function () { /* fail silent */ });
      }

      /* Detectar apertura del cart drawer (Dawn pattern: .active en cart-drawer) */
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        var obs = new MutationObserver(function () {
          if (drawer.classList.contains('active') ||
              drawer.classList.contains('is-open') ||
              drawer.hasAttribute('open')) {
            cleanup();
            obs.disconnect();
            /* Cart drawer abrió = bundle ya está en cart. Ahora sí añadir annual. */
            setTimeout(maybeAddAnnualPostBundle, 100);
          }
        });
        obs.observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });
        /* Safety timeout: si el drawer no abre en 3s, quitar loading + intentar add igual */
        setTimeout(function () {
          obs.disconnect();
          cleanup();
          maybeAddAnnualPostBundle();
        }, 3000);
      } else {
        /* Sin cart drawer detectable, timeout puro */
        setTimeout(function () { cleanup(); maybeAddAnnualPostBundle(); }, 2000);
      }
    });
  }

  /* Custom Urgency Bar — limpio (Pedro 2026-05-29).
     Layout 2 líneas (Pedro 2026-05-30):
       Línea 1: SOLO {N} DUCHAS · LOTE {pct}% VENDIDO
       Línea 2: TERMINA EN {d} DÍAS {h}H {m}M {s}S
     NO esconde Kaching (asume admin lo apagó). */

  /* Pedro 2026-06-06: última extensión, fecha fin 8-jun 23:59 CDMX */
  var URGENCY_BAR_END_ISO = '2026-06-08T23:59:59-06:00';
  var URGENCY_BAR_END_MS = new Date(URGENCY_BAR_END_ISO).getTime();

  function getCountdownStr() {
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    var d = URGENCY_BAR_END_MS - Date.now();
    /* Cuando expiró, clamp a "00D 00H 00M 00S" — mantener bar visible */
    if (d <= 0) return '00D 00H 00M 00S';
    var days = Math.floor(d / 86400000);
    var hours = Math.floor((d % 86400000) / 3600000);
    var mins = Math.floor((d % 3600000) / 60000);
    var secs = Math.floor((d % 60000) / 1000);
    /* Pedro 2026-06-06: siempre mostrar D (extensión final hasta 8-jun) */
    return pad(days) + 'D ' + pad(hours) + 'H ' + pad(mins) + 'M ' + pad(secs) + 'S';
  }

  function renderUrgencyBar() {
    if (!URGENCY_BAR_ENABLED) return;
    var tierWrap = document.querySelector('[data-agc-tier-wrap], .agc-tier-wrap');
    if (!tierWrap) return;
    if (document.querySelector('.agc-urgency-bar')) return; /* ya existe */

    var units = (typeof window.agcGetUnitsRemaining === 'function')
      ? window.agcGetUnitsRemaining() : null;
    if (typeof units !== 'number' || isNaN(units)) {
      /* Retry en 500ms si agc-hot-bar todavía no expuso window.agcGetUnitsRemaining */
      setTimeout(renderUrgencyBar, 500);
      return;
    }

    var bar = document.createElement('div');
    bar.className = 'agc-urgency-bar';
    bar.setAttribute('role', 'status');
    /* Pedro 2026-06-06: extensión final 8-jun. Texto + countdown integrado. */
    bar.innerHTML =
      '<span class="agc-urgency-bar__text">' +
        '<span class="agc-urgency-bar__label">ÚLTIMA EXTENSIÓN</span> · ' +
        '<span class="agc-urgency-bar__countdown">' + getCountdownStr() + '</span>' +
      '</span>';
    tierWrap.parentNode.insertBefore(bar, tierWrap);
  }

  function tickUrgencyBar() {
    var unitsEl = document.querySelector('.agc-urgency-bar__units');
    if (!unitsEl) return;
    if (typeof window.agcGetUnitsRemaining !== 'function') return;
    var u = window.agcGetUnitsRemaining();
    if (typeof u === 'number' && !isNaN(u)) unitsEl.textContent = u;
  }

  function tickUrgencyBarCountdown() {
    /* Pedro 2026-06-06: reactivado para extensión final 8-jun. */
    var cdEl = document.querySelector('.agc-urgency-bar__countdown');
    if (!cdEl) return;
    cdEl.textContent = getCountdownStr();
  }

  /* ANNUAL UPSELL T1: sección independiente Apple-style + indicador verde
     "Primer filtro automático mes 12" inyectado en el bar 1 cuando está active.
     Gated por ANNUAL_PDP_ENABLED feature flag (ver constantes arriba). */
  function injectAnnualUpsellT1() {
    if (!ANNUAL_PDP_ENABLED) return false; /* feature flag: skip render */
    var block = document.querySelector('[data-deal-block-id="' + KACHING_BLOCK_ID + '"]');
    if (!block) return false;
    var bar = block.querySelector('.kaching-bundles__bar[data-agc-bar-index="1"]');
    if (!bar) return false;
    if (document.querySelector('.agc-annual-card')) return true;

    /* Indicador verde dentro del bar 1 subtitle (matching Kaching mes 6/mes 9 style).
       Pedro 2026-06-09: rollback a "mes 12" — Ritual Anual 3 filtros,
       starter + 3 × 3 meses = 12 meses cobertura, primer renewal en mes 12. */
    var subtitle = bar.querySelector('.kaching-bundles__bar-subtitle');
    if (subtitle && !subtitle.querySelector('.agc-annual-month12')) {
      var monthSpan = document.createElement('small');
      monthSpan.className = 'agc-annual-month12';
      monthSpan.textContent = 'Primer filtro automático mes 12';
      /* Insertar antes del último <small> "Pausa o cancela" si existe */
      var small = subtitle.querySelector('small');
      if (small) subtitle.insertBefore(monthSpan, small);
      else subtitle.appendChild(monthSpan);
    }

    /* Row compacto seamless con el bundle Kaching — inyectado como sibling del bar 1,
       dentro del .kaching-bundles__bars container. Mismo lenguaje visual que un upsell
       Kaching, pero 100% bajo nuestro control. */
    var card = document.createElement('div');
    card.className = 'agc-annual-card' + (ANNUAL_DISPLAY_MODE === 'pill' ? ' agc-annual-card--pill' : '');
    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-pressed', 'false');
    card.setAttribute('aria-label', 'Sumar ritual anual de filtros');
    card.setAttribute('data-variant-id', String(ANNUAL_VARIANT_ID));
    /* Pedro 2026-06-06: Apple-style visual "3 + 1 GRATIS" con 4 PNGs del filtro
       chiquitos. Los primeros 3 ligeramente overlapped (stacked), separador "+",
       4to con tag "GRATIS" en verde forest. Reemplaza el badge "3x2" textual. */
    card.innerHTML =
      '<span class="agc-annual-card__check" aria-hidden="true">' +
        '<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
          '<path d="M12.334 1 5 8.333 1.667 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</span>' +
      '<img class="agc-annual-card__img" src="' + ANNUAL_IMAGE + '" alt="" loading="lazy" width="44" height="44">' +
      '<div class="agc-annual-card__text">' +
        '<span class="agc-annual-card__title-row">' +
          '<span class="agc-annual-card__title">Set Anual Filtros</span>' +
          '<span class="agc-annual-card__filters" aria-hidden="true">' +
            '<span class="agc-annual-card__count">3</span>' +
            '<span class="agc-annual-card__stack">' +
              '<img class="agc-annual-card__filter" src="' + ANNUAL_FILTER_PNG + '" alt="" loading="lazy">' +
              '<img class="agc-annual-card__filter" src="' + ANNUAL_FILTER_PNG + '" alt="" loading="lazy">' +
              '<img class="agc-annual-card__filter" src="' + ANNUAL_FILTER_PNG + '" alt="" loading="lazy">' +
            '</span>' +
            '<span class="agc-annual-card__plus">+</span>' +
            '<span class="agc-annual-card__free-group">' +
              '<span class="agc-annual-card__count">1</span>' +
              '<img class="agc-annual-card__filter agc-annual-card__filter--free" src="' + ANNUAL_FILTER_PNG + '" alt="" loading="lazy">' +
              '<span class="agc-annual-card__free-tag">GRATIS</span>' +
            '</span>' +
          '</span>' +
        '</span>' +
        '<span class="agc-annual-card__sub">15 meses de agua limpia</span>' +
      '</div>' +
      '<div class="agc-annual-card__price-wrap">' +
        '<span class="agc-annual-card__price">' + ANNUAL_PRICE_FMT + '</span>' +
        '<span class="agc-annual-card__compare">' + ANNUAL_COMPARE_FMT + '</span>' +
      '</div>';

    /* Insertar inmediatamente después del bar 1, antes de bar 2.
       Sibling del bar — no descendant del <label>. */
    if (bar.nextSibling) {
      bar.parentNode.insertBefore(card, bar.nextSibling);
    } else {
      bar.parentNode.appendChild(card);
    }

    var _cartOpInFlight = false;

    function applyVisualState(pressed) {
      card.classList.toggle('is-active', pressed);
      card.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      bar.classList.toggle('agc-annual-month12-on', pressed);
      try {
        if (pressed) sessionStorage.setItem(ANNUAL_STATE_KEY, '1');
        else sessionStorage.removeItem(ANNUAL_STATE_KEY);
      } catch (err) {}
    }

    /* APPROACH A: pill toggle NO toca cart en ON (defer al main ATC).
       Toggle OFF sí remueve si está en cart — pero ese path NO dispara AddToCart
       en Meta (es product_removed_from_cart event, distinto), así que safe. */
    function syncCart(pressed) {
      if (pressed) return; /* nothing to do — annual se añade en main ATC click */

      /* Toggle OFF: solo remover del cart si annual está presente (post-ATC case). */
      if (_cartOpInFlight) return;
      _cartOpInFlight = true;

      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = (cart.items || []).some(function (i) {
            return Number(i.variant_id) === ANNUAL_VARIANT_ID;
          });
          if (!inCart) return null;
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: String(ANNUAL_VARIANT_ID), quantity: 0 })
          });
        })
        .catch(function () {})
        .then(function () { _cartOpInFlight = false; });
    }

    /* Pedro 2026-06-06: pre-select by default — opt-out pattern para test attach rate.
       Track explicit dismissal en sessionStorage separado del ANNUAL_STATE_KEY (que
       solo refleja estado actual). Si user lo desmarca, NO se pre-selecciona de nuevo
       en navegación dentro de la misma sesión. Nueva sesión = pre-seleccionado otra vez. */
    var ANNUAL_DISMISSED_KEY = 'agc_annual_user_dismissed';

    function toggle() {
      var next = card.getAttribute('aria-pressed') !== 'true';
      applyVisualState(next);
      syncCart(next);
      /* Track dismissal: solo se setea cuando user explícitamente desmarca */
      try {
        if (!next) sessionStorage.setItem(ANNUAL_DISMISSED_KEY, '1');
        else sessionStorage.removeItem(ANNUAL_DISMISSED_KEY);
      } catch (err) {}
    }

    card.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggle();
    });

    card.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });

    /* APPROACH A: pre-select por default (opt-out) — solo visual + flag.
       NO toca cart hasta que user click main ATC. Si user lo desmarcó en esta
       sesión, respetar (no pre-seleccionar). Nueva sesión → pre-select otra vez. */
    try {
      var userDismissed = sessionStorage.getItem(ANNUAL_DISMISSED_KEY) === '1';
      if (!userDismissed) {
        applyVisualState(true); /* setea visual + ANNUAL_STATE_KEY='1' (flag para main ATC) */
      }
    } catch (err) {}

    return true;
  }

  /* ATC hook removido — el Set Anual se add/remove al cart cuando el user
     marca/desmarca el checkbox. El ATC del bundle queda sin delay extra. */
  function hookAnnualATC() {}

  function hideKachingDealNames() {
    document.querySelectorAll('.agc-discount-code').forEach(function (el) {
      var txt = (el.textContent || '').trim();
      // Detectar patrones Kaching: "1 Ducha + Filtro", "2 Duchas + Filtro", "3 Duchas + Filtro", "3x Duchas + Filtro"
      if (/^\d+x?\s*duchas?\s*\+\s*filtro/i.test(txt)) {
        el.style.display = 'none';
        el.setAttribute('data-agc-hidden-kaching', 'true');
      }
    });
  }

  function setupKachingDealNameHider() {
    // Run inmediato
    hideKachingDealNames();

    // Re-run cuando hay cart updates (usando debounce)
    var debounceTimer = null;
    function schedule() {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(hideKachingDealNames, 150);
    }

    // Escuchar eventos de cart updates típicos del theme
    document.addEventListener('cart:updated', schedule);
    document.addEventListener('cart:refresh', schedule);
    document.addEventListener('cart:items-updated', schedule);

    // MutationObserver del cart drawer (limitado a childList, sin attributes)
    var cartDrawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
    if (cartDrawer && 'MutationObserver' in window) {
      var cartObs = new MutationObserver(schedule);
      cartObs.observe(cartDrawer, { childList: true, subtree: true });
    }

    // Re-run periódico durante los primeros 10s después de cualquier ATC click
    document.addEventListener('click', function (e) {
      var target = e.target;
      // Detectar click en cualquier ATC (Kaching o tema)
      if (target.closest('.product-form__submit, [name="add"], .kaching-bundles__bar, [data-kaching-atc]')) {
        var ticks = 0;
        var atcWatch = setInterval(function () {
          hideKachingDealNames();
          if (++ticks >= 20) clearInterval(atcWatch); // 20 × 500ms = 10s
        }, 500);
      }
    }, true);
  }

  /* Public API: consumido por cart-drawer.liquid (_agcTierUpgrade) para hacer
     upgrade Tier 1→2/3 desde el cart sin redirect. switchTier hace click en el
     Kaching bar correspondiente, lo que prepara el bundle para el próximo ATC. */
  window.AGC_switchTier = switchTier;
  window.AGC_selectKachingBar = selectKachingBar;

  /* ┌────────────────────────────────────────────────────────────────────────┐
     │  APPROACH A — Defer pill cart-add to main ATC click (Pedro 2026-06-06) │
     │                                                                        │
     │  El pill Set Anual NO toca cart cuando se togglea (pre-select o        │
     │  manual). Solo cambia visual + sessionStorage flag (ANNUAL_STATE_KEY). │
     │  Al click del botón principal "AGREGAR A MI CARRITO", si el flag está │
     │  set, añadimos el Annual al cart junto con el bundle.                  │
     │                                                                        │
     │  Resultado: Meta Pixel NO ve AddToCart desde el pill (cero /cart/add  │
     │  desde toggle). El AddToCart solo dispara post-main-ATC, que es el    │
     │  comportamiento correcto según Pedro.                                  │
     │                                                                        │
     │  Edge case: si user toggle OFF post-ATC (annual ya está en cart),     │
     │  llamamos /cart/change.js qty=0 — esto dispara product_removed_from_  │
     │  cart, NO product_added_to_cart, así que Meta no fire AddToCart.      │
     └────────────────────────────────────────────────────────────────────────┘ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* Telemetry block removido 2026-05-25 — debugging completado, monkey-patch de
   window.fetch eliminado para reducir overhead en cada request. */
